<template>
  <zt-modal :active="noLinkingModalActive" @close="confirmCancel" max-width="42rem" :z-index="200"
    :fullscreen="isMobile">
    <template slot="modal-header">
      <div class="p-4 font-normal text-zt-lg text-center md:text-left">
        {{ $t("message.homeComponent.linkUserLogin.byEmail.finish") }}
      </div>
    </template>
    <div class="p-10 text-center md:flex md:text-left">
      <div class="md:w-1/4">
        <zt-icon name="thumb-up" class="text-zt-primary-200" :style="{ fontSize: '6rem' }"></zt-icon>
      </div>
      <div class="md:w-3/4">
        <h1 class="text-bold text-xl mb-4  md:mb-3">
          {{ $t("message.homeComponent.linkUserLogin.byEmail.no_success") }}
        </h1>
        <div class="text-left">
          <p class=" text-zt-dark-500">{{ $t("message.homeComponent.linkUserLogin.byEmail.redirect_home") }}</p>
        </div>
      </div>
    </div>
    <div
      class="zt-modal-footer grey-background border-b flex p-5 fixed md:relative bottom-0 right-0 left-0 justify-end">

      <div class="">
        <zt-button data-vs-button="active-step" class="ml-1 w-11/12" @click="confirmCancel()">{{
          $t("message.linkUser.successModal.toHome") }}</zt-button>
      </div>
    </div>
  </zt-modal>

</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'Confirm',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    noLinkingModalActive: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    ...mapMutations(['CLEAR_CANDIDATES', 'CLEAR_PROFILE']),
    confirmCancel() {
      this.closeModal()
      this.CLEAR_PROFILE()
      this.CLEAR_CANDIDATES()
      this.$router.push({ path: '/' })
    },
    closeModal() {
      this.$emit('update:noLinkingModalActive', false);
    },
  }
}
</script>
<style scoped>
.grey-background {
  background-color: #ebebeb;
}
</style>